<template>
	<div class="videofeedback">
		<div class="feedback">
			<div class="neirong">
				
						<ul class="typeList">
							<li v-for="(typeListItem, typeListIndex) in typeList" :class="typeListItem.open ? 'ac' : ''" @click="onTypeList(typeListIndex, typeListItem.id)"
							 :key="typeListIndex">
								{{ typeListItem.name }}
							</li>
						</ul>
						</div>
						<!--  -->
						<textarea placeholder="请输入反馈内容" v-model="feedbackContent" class="textarea" />
					<div class="btn">
						<div class="tijiao" @click="onSubmit">提交</div>
						
						
					</div>	
		</div>
	
		
	</div>
</template>

<script>
	var that;
	import {
		AddNews
	} from "../api/api.js"
	export default{
		data(){
			return{
               
				typeList: [
				  {
				    open: false,
				    id: 21,
				    name: "老师讲解问题",
				  },
				  {
				    open: false,
				    id: 22,
				    name: "视频与大纲不符",
				  },
				  {
				    open: false,
				    id: 23,
				    name: "视频音量问题",
				  },
				  {
				    open: false,
				    id: 24,
				    name: "视频内容与其科目不符",
				  },
				  {
				    open: false,
				    id: 25,
				    name: "考点详解图片不显示",
				  },
				  {
				    open: false,
				    id: 27,
				    name: "专项练习问题",
				  },
				  {
				    open: false,
				    id: 26,
				    name: "其他问题",
				  },
				],
				errorType: [],
				feedbackContent:'',
			
			}
		},
		mounted() {
			that=this
			
		},
		methods:{
			onTypeList: function (index, id) {
			  let typeList = that.typeList;
			  //添加选中标识
			  typeList[index].open = !typeList[index].open;
			  //判断选中把id储存
			  if (typeList[index].open == true) {
			    that.errorType.push(id);
			  } else {
			    that.errorType.sort(); //排序
			    let indexs = that.errorType.lastIndexOf(id); //从后面开始找，获取位置
			    that.errorType.splice(indexs, 1); //删除对应的数字
			  }
			},
			
			
			
		}
	}
</script>

<style scoped="scoped">
	.feedback {
	  padding: 20px 20px;
	  /* box-sizing: border-box; */
	}
	.typeList li.ac {
	  color: #fff;
	  background: #5bb8ff;
	  border: 1px solid #5bb8ff;
	  cursor: pointer;
	}
	.typeList ul{
		margin-left: -50px;
	}
	.typeList li {
		list-style: none;
	  float: left;
	  color: #6d6d6d;
	  border: 1px solid #6d6d6d;
	  margin-right: 10px;
	  padding: 4px;
	  margin-bottom: 10px;
	  border-radius: 3px;
	  font-size: 15px;
	  cursor: pointer;
	}
	.textarea {
	  /* border: none; */
	  outline: none;
	  width: 100%;
	  height: 150px;
	  padding: 30px;
	  font-size: 16px;
	  color: #333333;
	  background: #f4f4f4;
	  box-sizing: border-box;
	  border: 1px solid #ccc;
	  margin-bottom: 20px;
	}
	.neirong{
		width: 80%;
		height: 60px;
		margin-left: -35px;
	}
	.tijiao{
		/* float: right; */
		/* width: 100px;
		height: 50px; */
		
		background-color: #5bb8ff;
		color: #ffffff;
		margin-left: 95%;
		text-align: center;
		padding-top: 8px;
		padding-bottom: 8px;
	    border-radius: 5px;
		font-size: 15px;
		
		/* margin-bottom: 50px; */
	}
		
		
</style>
